import { BadgeVariant } from "./common";

export enum EmployeeStatus {
  ACTIVE = "Active",
  AT_RISK = "At-risk",
  WARNING = "Warning"
}

export enum EmploymentType {
  FULL_TIME = "Full time",
  PART_TIME = "Part time",
  ON_CALL = "On Call",
  CONTRACT = "Contract",
  TEMPORARY = "Temporary"
}

export enum EmploymentStatus {
  ACTIVE = "Active",
  CLOSED = "Closed",
  LEAVE = "Leave"
}

export enum JobCategory {
  NURSE = "Nurse",
  AIDE = "Aides",
  THERAPIST = "Therapist",
  MANAGER = "Manager",
  ADMINISTRATOR = "Administrator"
}

export enum Region {
  NORTH = "North",
  SOUTH = "South",
  EAST = "East",
  WEST = "West",
  NORTHERN_PLAINS = "Northern Plains",
  CENTRAL = "Central"
}

export enum TenureRange {
  LESS_THAN_1_YEAR = "Less than 1 year",
  ONE_TO_TWO_YEARS = "1 year - 2 years",
  THREE_TO_EIGHT_YEARS = "3 - 8 years",
  MORE_THAN_8_YEARS = "More than 8 years"
}

export interface EmployeeProfile {
  employee_id: number;
  office_location: string;
  region: string;
  supervisor: string;
  supervisor_email: string;
  category: string;
  type: string;
  job_title: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string;
  profile_picture_url: string | null;
  hired_at: string;
  is_active: boolean;
  tenure: string;
}

export interface EmployeeData {
  name: string;
  initials: string;
  jobTitle: string;
  location: string;
  state: string;
  status: EmployeeStatus | null;
  hireDate: string;
  tenure: string;
  supervisor: string;
  department: string;
  phone: string;
  email: string;
}

export interface ContactData {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

export interface WorkData {
  location: string;
  region: string;
  tenure: string;
  hireDate: string;
  supervisor: string;
  employmentType: string;
  employmentStatus: string;
} 

export enum SurveyStatus {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export enum SurveyType {
  MULTIPLE_CHOICE = 'multiple_choice',
  NUMERICAL = 'numerical',
  FREE_RESPONSE = 'free_response'
}


export interface Employee {
  id: string;
  name: string;
  initials: string;
  role: string;
  location: string;
  state: string;
  hireDate: string;
  experience: string;
  manager: string;
  managerRole: string;
  phone: string;
  email: string;
  status: BadgeVariant;
}

export interface SurveyQuestion {
  id: string;
  question: string;
  answer: string;
  score: number;
  status: SurveyStatus | null;
  type: SurveyType;

}

export interface Survey {
  id: string;
  title: string;
  date: string;
  questions: SurveyQuestion[];
  openEndedResponse?: string;
  aiSummary: string;
  keyConcerns: string[];
}

export interface Escalation {
  id: string;
  surveyId: string;
  surveyTitle?: string;
  level: number;
  reason: string;
  status: string;
  aiSuggestions: string[];
  createdAt: string;
}

export interface FeedItem {
  id: string;
  type: 'system' | 'action' | 'survey';
  title: string;
  description?: string;
  date: string;
  icon: string;
  iconVariant?: BadgeVariant;
  aiSuggestion?: string;
}

export interface SurveyTimelineItem {
  survey_id: number;
  trigger_day: string;
  post_termination: boolean;
  completed: boolean;
  "Response Rate": number;
  created_at: string;
  trigger_day_abbr: string;
  "Overall Sentiment": string;
  "Sentiment Score": number;
}

export interface EmployeeWithProfile {
  id?: number;
  profile?: {
    employee_id: number;
    office_location: string;
    region: string;
    supervisor?: string;
    supervisor_email?: string | null;
    category?: string;
    type?: string | null;
    job_title: string;
    first_name: string;
    last_name: string;
    phone_number: string;
    email: string;
    profile_picture_url?: string | null;
    hired_at: string;
    is_active: boolean;
    tenure?: string;
  };
}

